import { useRef } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import DocsSidebar from '../../components/DocsSidebar'
import OnThisPage from '../../components/OnThisPage'

const NAV = `## Integration Server
- [Overview & Capabilities](/software/integration-server)
- [Installation & Configuration](/software/integration-server/installation)
- [Webhooks & Authentication](/software/integration-server/webhooks)
`

export default function IntegrationServer() {
  const location = useLocation()
  const proseRef = useRef<HTMLDivElement>(null)

  return (
    <section className="section api-doc-page">
      <div className="docs-layout">
        <aside className="docs-sidebar">
          <div className="docs-sidebar-inner">
            <DocsSidebar markdown={NAV} />
          </div>
        </aside>
        <div className="docs-content" ref={proseRef}>
          <Outlet/>
        </div>
        <OnThisPage containerRef={proseRef} watch={location.pathname}/>
      </div>
    </section>
  )
}
